import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";

const Downloadbutton = forwardRef((_, ref) => {
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    const handler = (event) => {
      event.preventDefault();
      console.log("PWA Install Prompt Available");
      setPromptInstall(event);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  useImperativeHandle(ref, () => ({
    triggerInstall: () => {
      if (promptInstall) {
        promptInstall.prompt();
      } else {
        alert("PWA installation is not available");
      }
    },
  }));

  return null;
});

export default Downloadbutton;
